import React from 'react';
import { Form, Input, Select } from 'antd';
import { Button } from '@/components/Button';
import { USER_ROLES, USER_ROLE_LABELS, type UserRole } from '../utils/roles';
import styles from './InviteUserForm.module.scss';

interface InviteUserFormValues {
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
}

interface InviteUserFormProps {
  onSubmit: (values: InviteUserFormValues) => Promise<void>;
  onCancel: () => void;
}

export const InviteUserForm: React.FunctionComponent<InviteUserFormProps> = ({
  onSubmit,
  onCancel,
}) => {
  const [form] = Form.useForm<InviteUserFormValues>();

  const roleOptions = Object.values(USER_ROLES).map((r) => ({ value: r, label: USER_ROLE_LABELS[r] }));

  const handleFinish = async (values: InviteUserFormValues) => {
    await onSubmit(values);
    form.resetFields();
  };

  return (
    <Form 
      form={form} 
      layout="vertical" 
      onFinish={handleFinish} 
      initialValues={{ role: USER_ROLES.USER }}
    >
      <Form.Item 
        name="firstName" 
        label="First Name" 
        rules={[{ required: true, message: 'First name is required' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item 
        name="lastName" 
        label="Last Name"
      >
        <Input />
      </Form.Item>
      <Form.Item 
        name="email" 
        label="Email" 
        rules={[
          { required: true, message: 'Email is required' },
          { type: 'email', message: 'Enter a valid email' },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item 
        name="role" 
        label="Role"
      >
        <Select options={roleOptions} />
      </Form.Item>
      <Form.Item className={styles.actionsFormItem}>
        <div className={styles.actions}>
          <Button appearance="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button appearance="solid" htmlType="submit">
            Add User
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};
